export default __webpack_public_path__ + "static/media/plus-icon.09afbc0d.svg";